import {Section} from '../UI/IgmtInk'

const Footer = props => {
  return <Section className='text-center p-4 pt-9'>© 2022 Ivan Gregor Tabalno. All rights reserved.</Section>
}

export default Footer
